export default __webpack_public_path__ + "static/media/trash-icon.98846de7.svg";